import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { usePostHog } from 'posthog-js/react';

const PostHogPageViewTracker = () => {
  const location = useLocation();
  const postHog = usePostHog();

  useEffect(() => {
    try {
      if (!postHog) return;

      const posthogDetails = localStorage.getItem('posthogdetails');
      const userId = localStorage.getItem('userId');

      if (posthogDetails) {
        const posthogDetailsParsed = JSON.parse(posthogDetails);
        postHog.capture('$pageview', {
          viewAsUserName: posthogDetailsParsed?.userProperties?.viewAsUserName || "",
          viewAsUserEmail: posthogDetailsParsed?.userProperties?.viewAsUserEmail || "",
          internalTeam: posthogDetailsParsed?.userProperties?.internalTeam || false,
        });
      } else if (userId) {
        postHog.capture('$pageview', {
          internalTeam: localStorage.getItem('isStaff') === 'true',
        });
      }
    } catch {
    }
  }, [location, postHog]);

  return null;
};
export default PostHogPageViewTracker;
